export default "__VITE_ASSET__CCL7Lx9u__"